<p>sse-test works!</p>

<ul>
  @for (time of getTimes(); track time) {
    <li>{{time}}</li>
  }
</ul>
